<template>
  <div class="content">
        <div class="build-CURD">
          <div class="build-bar">
            <span>名称：</span>
            <div style="width:10vw;">
              <el-input placeholder="请输入题库名称" v-model="search.name"></el-input>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>

            <el-button type="primary" class="add-user" @click="addFun">添加题库</el-button>
          </div>
          <div class="build-table">
            <el-table
              :data="listData"
              border
              height="92%"
              style="width: 100%;"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column
                type="index"
                label="序号"
                width="60">
              </el-table-column>
              <el-table-column label="题库名称">
                <template slot-scope="scope">
                  <a>{{ scope.row.name}}</a>
                </template>
              </el-table-column>
              <el-table-column label="组织类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.groupType=='1'">项目</span>
                  <span v-else>企业</span>
                </template>
              </el-table-column>
              <el-table-column label="所属企业">
                <template slot-scope="scope">
                  <span>{{ scope.row.projectName }}</span>
                </template>
              </el-table-column>
              
              <el-table-column label="排序" sort>
                <template slot-scope="scope">
                  <span>{{ scope.row.sort }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="handleEdit1(scope.$index, scope.row)">试题管理</el-button>
                  <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页展示 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
            <!-- 新增窗口 -->
            <el-dialog
              :title="dialogTitle"
              :visible.sync="addFormVisible"
              center
              width="500px"
              :append-to-body="true"
              :lock-scroll="false"
              class="add-form"
            >
              <el-form :model="addForm" label-width="120px" ref="ruleForm">
                <el-form-item label="题库名称" required>
                  <el-input v-model="addForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                  <el-input v-model="addForm.sort" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="addForm.remarks"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="addFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('ruleForm')">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
  </div>
</template>

<script>
import myHttp from "../../untils/port.js";
import util from "../../untils/util.js"
import base from '../../untils/base'
export default {
  data() {
    return {
      search:{  //查询
        name:'',
        groupId:''
      },
      listData:[], //表格数据
      addForm:{
        id:'',
        name:'',
        sort:'',
        remarks:'',
      },
      dialogTitle:'',
      addFormVisible:false,
      groupId:'',
      currentPage:1,
      pageSize:10,
      totalItems:0,
      dataText:'数据加载中...',
    }
  },
  mounted(){
    this.groupId = this.$store.state.groupId;
    if(''==this.groupId){
      this.$store.commit('setGroupId');
      this.groupId = this.$store.state.groupId;
    }
    if(util.session.get('roleId')=='3'){
      this.search.groupType = '3'
    }else if(util.session.get('roleId')=='4'){
      this.search.groupType = '1'
    }else if(util.session.get('roleId') == '5'){
      this.search.groupType = '2'
    }
    this.search.groupId = this.groupId;
    this.getData();
  },
  methods: {
    //查询
    doFilter(){
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage();
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData();
    },
    // 获取数据
    getData() {
      var that = this;
      this.search.pageSize = this.pageSize;
      this.search.pageNum = this.currentPage;
      this.search.module = 'enterprise'
      this.search.storeType = '1'
      myHttp.getStoreList(this.search).then(function(resp){
        if(resp.data.code=="200"){
            var list = resp.data.data.pageInfo.list||[];
            that.totalItems = resp.data.data.pageInfo.total||0;
            that.listData = list;
            if(that.listData.length==0){
                that.dataText = "暂无数据"
            }
        }else{
          that.$message.error(resp.data.msg);
          that.dataText = "暂无数据"
        }
      },function(){});
    },
    //修改
    handleEdit(index,row){
      this.dialogTitle = "修改题库";
      this.addFormVisible = true;
      this.addForm.id = row.id;
      this.addForm.name = row.name;
      this.addForm.sort = row.sort;
      this.addForm.remarks = row.remarks;
      this.addForm.module = 'enterprise'
    },
    // 题库管理
    handleEdit1(index,row){
      this.$router.push({
        path:'/examList1',
        query:{
          id:row.id
        }
      })
    },
    //保存
    sumbitAddRow(formName){
      var that = this;
      this.addForm.groupId = this.groupId;
      this.addForm.groupType = this.search.groupType;
      this.$refs[formName].validate((valid) => {
          if (valid) {
            if(that.addForm.id==""){
              myHttp.createStore(that.addForm).then(function(resp){
                if(resp.data.code=="200"){
                    that.addFormVisible = false;
                    that.$message.success('题库创建成功');
                    that.getData();
                }else{
                    that.$message.error(resp.data.msg);
                }
              });
            }else{
              myHttp.updateStore(that.addForm).then(function(resp){
                if(resp.data.code=="200"){
                    that.addFormVisible = false;
                    that.$message.success('题库修改成功');
                    that.getData();
                }else{
                    that.$message.error(resp.data.msg);
                }
              });
            }
          }
      });
    },
    //添加
    addFun(){
      this.dialogTitle = '添加题库';
      this.addForm={
        id:'',
        name:'',
        sort:'',
        remarks:'',
        module:'enterprise',
        storeType:'1'
      },
      this.addFormVisible = true;
    },
    //删除
    handleDel(index,row){
      var that = this;
      this.$confirm('此操作将永久删除该题库, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.delStore({
          id:row.id
        }).then(function(resp){
          if(resp.data.code=="200"){
              that.$message.success('题库删除成功');
              that.getData();
          }else{
              that.$message.error(resp.data.msg);
          }
        });
      }).catch(err => {})
    },
    
  }
}
</script>

<style>
@import '../../assets/css/common.css';

</style>

<style scoped>
* {
  box-sizing: border-box;
}
.el-table--border{
      border: 1px solid #ebeef5;
}
.content{
  height: 100%;
  width: 100%;
  background: #fff;
}
.build-CURD{
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table{
  width: 100%;
  height: calc( 100% - 5vh );
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.build-bar{
  display: flex;
  align-content: center;
  align-items: center;
  padding-bottom: 2vh;
}
.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-bar .el-button{
  background-color: #17b2fe;
  border-color: #17b2fe;
  margin-left: 30px;
}
</style>

<style>
    .add-form .el-select .el-input{
      width: 100%;
    }
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>